import {Form, Input, Checkbox} from 'antd';
import {xor} from 'lodash-es';
import React, {useState, FC, useEffect} from 'react';

import {CustomSelect} from 'components/form/inputs/custom-select';
import {ICompanyGroupStatePartInfoItem, IOption} from 'pages/ais/organization-structure-v5/model/types';

import styles from './company-group-state-part-info-item.module.less';

export const CompanyGroupStatePartInfoItem: FC<ICompanyGroupStatePartInfoItem> = ({
    form,
    setSelectedRows,
    selectedRows,
    field,
}: ICompanyGroupStatePartInfoItem) => {
    const [isPercentRequreid, setIsPercentRequired] = useState<boolean>(false);

    const [isCommentRequreid, setIsCommentRequreid] = useState<boolean>(false);

    const handleChange = (_: any, option: IOption) => {
        setIsPercentRequired(option.children === 'прямое' || option.children === 'косвенное');
        setIsCommentRequreid(option.children === 'иное');
    };

    const statePartType = form.getFieldValue(['companyGroupStatePartInfoDtos', field.name, 'statePartType']);

    useEffect(() => {
        if (statePartType && statePartType.description) {
            const description = statePartType.description || statePartType;
            const isPercent = description === 'прямое' || description === 'косвенное';
            const isComment = description === 'иное';
            setIsPercentRequired(isPercent);
            setIsCommentRequreid(isComment);
        }
    }, [statePartType]);

    return (
        <article
            key={field.name}
            className="d-flex flex-column"
        >
            <section className="d-flex gap-2">
                <Form.Item label={<>&nbsp;</>}>
                    <Checkbox
                        checked={selectedRows.includes(field.name)}
                        onClick={() => setSelectedRows(xor(selectedRows, [field.name]))}
                    />
                </Form.Item>
                <div className="d-flex gap-2">
                    <Form.Item
                        rules={[{required: true}]}
                        label="Способ государственного участия"
                        name={[field.name, 'statePartType']}
                        className={styles['company-group-state-part-item__state-part-type']}
                    >
                        <CustomSelect
                            onChange={handleChange}
                            settings={{
                                url: 'valueLists/FLEX_VALUE?sublistCode=state_part_type_v5',
                                valuePath: 'id',
                                labelPath: 'description',
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        rules={[{required: isPercentRequreid}]}
                        label="Доля государственного участия, в процентах"
                        name={[field.name, 'statePartShare']}
                        className={styles['company-group-state-part-item__state-part-share']}
                    >
                        <Input
                            onKeyPress={(e) => {
                                if (!/[0-9.]/.test(e.key)) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </Form.Item>
                </div>
            </section>
            <section>
                <Form.Item
                    rules={[
                        {required: isCommentRequreid},
                        {pattern: /^.{1,100}$/, message: 'Количество символов должно быть не более 1000'},
                    ]}
                    hidden={!isCommentRequreid}
                    validateTrigger="onBlur"
                    label="Комментарий по иным случаям государственного участия"
                    name={[field.name, 'statePartComment']}
                    className="w-100"
                >
                    <Input />
                </Form.Item>
            </section>
        </article>
    );
};
